// climate/shell.jsx — full-takeover Climate surface.
//
// Replaces the centered AClimateModal. Wraps the existing
// AClimateModal body (big number + Ecobee-style dotted scale + mode
// chips) inside TakeoverShell.

import { TakeoverShell, AClimateModal } from '../direction-a.jsx';

export function ClimateShell({ T, open, onClose, rooms, focusRoomId, viewport, update }) {
  if (!open || !focusRoomId) return null;
  const room = rooms?.find((r) => r.id === focusRoomId);
  if (!room) return null;
  // Mode in the eyebrow gives at-a-glance context (auto/heat/cool/off)
  // matching the room-tile label format.
  const eyebrow = room.mode ? `Climate · ${room.mode}` : 'Climate';
  return (
    <TakeoverShell T={T} viewport={viewport}
      eyebrow={eyebrow} title={room.name} onClose={onClose}>
      <AClimateModal T={T} room={room} update={update}/>
    </TakeoverShell>
  );
}
